import { render } from "./MatchContent2COPA.vue?vue&type=template&id=1ff4ba68&scoped=true"
import script from "./MatchContent2COPA.vue?vue&type=script&lang=js"
export * from "./MatchContent2COPA.vue?vue&type=script&lang=js"

import "./MatchContent2COPA.vue?vue&type=style&index=0&id=1ff4ba68&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff4ba68"]])

export default __exports__